module.exports = __webpack_public_path__ + "img/subiz-mono.0828dc90.svg";